'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * RUM view.name 을 실제 경로로 설정 (heatmap·replay 페이지별).
 * page_template(메트릭 dimension)은 datadog-init beforeSend 에서 설정한다.
 */
export default function DatadogViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    datadogRum.setViewName(pathname);
  }, [pathname]);

  return null;
}
